import React from 'react';
import { Link } from 'react-router-dom';
import "./Privacypolices.scss"
import HANUMANJI from "../../images/logo.webp";

function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <div className="container">
        <div className="logoContainer">
          <img src={HANUMANJI} alt="" className="logoImage" />
          <div className="logoText">
            <span className="maintitle" data-text="Pavanputra">Pavanputra</span>
          </div>
        </div>

        <div className="content">
          <h1>Privacy Policy</h1>
          <p>
            At Pavanputra LLC, we are committed to safeguarding your privacy. This Privacy Policy outlines how we collect, use, and protect your personal data when you use our Chatbot accessible via WhatsApp.
          </p>

          <h1>1. Information Collection</h1>
          <p>
            We collect information you provide while interacting with our Chatbot. This may include personal details, fitness-related queries, and other information shared during conversations.
          </p>

          <h1>2. Usage of Information</h1>
          <p>
            The information collected is used to improve our Chatbot's responses and provide personalized fitness-related insights. Your data is securely stored and analyzed to enhance user experience.
          </p>

          <h1>3. Information Sharing</h1>
          <p>
            We do not share your personal information with third parties for marketing purposes. However, we may share aggregated and anonymized data for research and analytics.
          </p>

          <h1>4. Security</h1>
          <p>
            We implement technical and organizational measures to protect your data from unauthorized access or disclosure. Your privacy and data security are of utmost importance to us.
          </p>

          <h1>5. Changes to Policy</h1>
          <p>
            Pavanputra LLC reserves the right to update this Privacy Policy. Any changes will be posted on this page. Continued use of our Chatbot after changes implies your acceptance of the revised policy.
          </p>

          <h1>6. Contact Us</h1>
          <p>
            If you have any questions or concerns regarding this Privacy Policy, please <Link to="/support">contact us</Link>.
          </p>
        </div>

        <div className="connectButton">
          <button className="connectbutton">
            <Link to="https://dashboard.pavan-putra.com" className="link">Connect Whatsapp</Link>
          </button>
        </div>

      </div>
    </div>
  );
}

export default PrivacyPolicy;
